import { isEmpty } from "lodash";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type { NewsCategoriesByType } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategoriesByType";
import type { NewsCategory } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategory";
import type {
    MatchingFunction,
    TranslatableNameWithType,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type { FilterNameResolver } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import { UNKNOWN_NAME_TRANSLATABLE } from "app/pages/sales-intelligence/sub-modules/signals/services/filters/const";
import filterNamingService from "app/pages/sales-intelligence/sub-modules/signals/services/filters/filterNamingService";
import { matchNewsCategoryToName } from "app/pages/sales-intelligence/sub-modules/signals/utils/news/filters";

function createAnyNewsCategoriesNameFactory(): FilterNameResolver {
    const matchValueToName: MatchingFunction = (category: NewsCategory) => {
        const { key } = matchNewsCategoryToName(category);

        return key;
    };

    return {
        buildName<F extends SignalFilters & { categories: readonly NewsCategory[] }>(
            filters: F,
            options: NewsCategoriesByType,
            translationOptions = { i18nKeyModifier: "" },
        ): Readonly<TranslatableNameWithType> {
            if (isEmpty(filters.categories)) {return { translatable: UNKNOWN_NAME_TRANSLATABLE };}

            const numberOfOptions = Object.values(options).flat().length;

            return filterNamingService.buildNameForSelection({
                values: filters.categories,
                numberOfOptions,
                matchValueToName,
                translationOptions,
            });
        },
    };
}

export default createAnyNewsCategoriesNameFactory;
